import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const GetJsonData = createAsyncThunk(
  "JsonData/GetJsonData",
  async (_, { rejectWithValue }) => {
    try {
    //   const response = await fetch('/grants/Helpers/main.json');
      const response = await fetch(` ${window.location.origin}/SRFund/Helpers/main.json`);
      // Extract data from the response object
      const data = await response.json(); // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const FetchDataJson = createSlice({
  name: "FetchDataJson",
  initialState: {
    JsonData: {},
    loadingJsonData: false,
    errorJsonData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetJsonData.pending, (state, action) => {
        state.loadingJsonData = true;
        state.JsonData = action.payload;
        state.errorJsonData = null;
      })
      .addCase(GetJsonData.fulfilled, (state, action) => {
        state.loadingJsonData = false;
        state.JsonData = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetJsonData.rejected, (state, action) => {
        state.loadingJsonData = false;
        state.errorJsonData = action.payload;
      });
  },
});

export default FetchDataJson.reducer;
